
<template lang="html">
    <data-table
        :headers="datatable.headers"
        :toolbar="datatable.toolbar"
        :actions="datatable.actions"
        :endpoint="datatable.endpoint"
        @rowClick="rowClick"
        @total_updated="update_count"
        storeId="tests"
        selectable
        ref="list"
    >
        <template slot="items" slot-scope="props">
            <td class="text-xs-left author">
                <!-- avatar on all tabs -->
				<avatar :item="props.item.user"></avatar>
                {{props.item.user.first_name}} {{props.item.user.last_name}}
            </td>
            <td class="text-xs-right">
                {{moment(props.item.created_at).format('DD/MM/YYYY')}}
            </td>
            <td class="text-xs-left status-box">
                <template v-if="getTestStatusColor(props.item) == '#FFFFFF'">
                    <v-icon class="ml-2 mr-2">mdi-checkbox-blank-circle-outline</v-icon>
                </template>
                <template v-else>
                    <v-icon :style="{color: getTestStatusColor(props.item)}" class="ml-2 mr-2">mdi-checkbox-blank-circle</v-icon>
                </template>
                {{getTestStatusLabel(props.item)}}
            </td>
            <td class="text-xs-center smaller-box">
                {{props.item.validated_elements_count}}
            </td>
            <td class="text-xs-center">
                {{props.item.failed_elements_count}}
            </td>
            <td class="text-xs-center">
                <v-btn
                icon
                flat
                v-if="props.item.status !== 'pending'"
                @click.stop="exportTestResult(props.item.id)"
                >
                    <v-icon color="grey">file_download</v-icon>
                </v-btn>
            </td>
        </template>
    </data-table>
</template>

<script>
import DataTable from '../../../components/DataTable.vue'
import RunTest from './RunTest.vue'
import DeleteTest from './DeleteTest.vue'
import TestPDF from './TestPDF.vue'
import moment from 'moment'
import { CommentTypes } from '../../../config/enum/CommentTypes'
import { TestStatuses } from '../../../config/enum/TestStatuses'
import { TestElementStatuses } from '../../../config/enum/TestElementStatuses'
import Avatar from '../../../components/avatar/Avatar.vue'

export default {
	components: { DataTable, Avatar },

	data() {
		return {
		    moment,
            TestPDF,
			datatable: {
				actions: [
                    { text: 'Réaliser un contrôle du produit', icon: 'add_circle', callback: () => {
                     this.$eventHub.$emit('open-modal', RunTest,{
                         product_id : this.$store.state.single.data.id,
                         product_label: this.$store.state.single.data.label,
                         element_type: 'comment',
                         run_new_test: true
                      }) }
                     }
				],
                toolbar: [
                    { icon: 'delete', callback: () => { this.$eventHub.$emit('open-modal',DeleteTest) } }
                ],
				headers: [
					{ text: 'Auteur',                    sortable: true, value: 'user_id', align: 'center', width: '25%'  },
					{ text: 'Date',                      sortable: true, value: 'created_at', width: '15%'  },
					{ text: 'Statut',                    sortable: true, value: 'status', align: 'center', width: '15%'  },
					{ text: 'Demandes validées',         sortable: true, value: 'validated_elements_count', width: '15%'   },
					{ text: 'Demandes\n\n non validées', sortable: true, value: 'failed_elements_count', width: '15%'},
					{ text: 'Compte rendu',              sortable: false, align: 'right', width: '15%'}
				],
				endpoint: {
					base: '/api/tests',
					filters: 'product_id|=|' + this.$route.params.id,
					embed: 'user,elements,validated_elements,failed_elements',
                    order:'updated_at|DESC'
				}
			}
		}
	},
	methods: {
        getTestStatusLabel(test) {
            if(!!test && !!test.status) {
                let testStatus = TestStatuses.find((el) => {
                    return el.value === test.status
                });
                return testStatus ? testStatus.label : '';
            } else {
                return ''
            }
        },
        getTestStatusColor(test) {
            if(!!test && !!test.status) {
                let testStatus = TestStatuses.find((el) => {
                    return el.value === test.status
                });
                return testStatus ? testStatus.color : '';
            } else {
                return ''
            }
        },
        getNbNotValidRequests(test) {
            if(!!test && !!test.elements) {
                return test.elements.filter((el) => {
                    return el.status === TestElementStatuses[0].value
                }).length
            } else {
                return ''
            }
        },
        getNbValidRequests(test) {
            if(!!test && !!test.elements) {

                return test.elements.filter((el) => {
                    return el.status === TestElementStatuses[1].value
                }).length;
            } else {
                return '';
            }
        },
        rowClick(item) {
            if(this.$store.state.auth.user.id === item.user_id || item.status != 'pending') {
                this.$eventHub.$emit('open-modal', RunTest, {
                    product_id : this.$store.state.single.data.id,
                    product_label: this.$store.state.single.data.label,
                    id : item.id,
                    status : item.status,
                    final_comment : item.final_comment,
                    read_only: false
                 });
            } else {
                this.$eventHub.$emit('open-snackbar','warning','Vous n\'êtes pas le créateur de ce test')
            }
        },
        update_count(count){
            this.$store.dispatch('updateSingleData', { key:'tests_count', value:count})
            this.$store.dispatch('updateSingleData', { key:'tests', value: this.$refs.list.items})
        },
        exportTestResult(id) {
            this.$eventHub.$emit('open-modal', TestPDF, {id:id})
        }
	},
	created() {
		this.$eventHub.$on('reload-list', () => {
			if (this.$refs.list) {
				this.$refs.list.reload()
			}
		})
	},
}
</script>

<style lang="stylus" scoped>

    .author-box{
        min-width: 200px !important
    }
    .status-box {
        min-width: 15rem
    }

</style>



// WEBPACK FOOTER //
// src/views/products/single/Tests.vue